import { IApolloSearchPartnersResult } from 'legacy/lut/classes/models/apollo'

import {
  initialPartnerData,
  PARTNER_COUNTRY_WITH_ENGLISH_NAME,
} from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'

export const mapPartnerFromApolloSearchResult = (data: IApolloSearchPartnersResult): IPartner => {
  const shoudCopyExtandedName = PARTNER_COUNTRY_WITH_ENGLISH_NAME.includes(data.country)
  const name = shoudCopyExtandedName ? data.extendedName : data.name

  return {
    ...initialPartnerData,
    addressLine1: data.addressLine1 || '',
    addressLine2: data.addressLine2 || '',
    addressLine3: data.addressLine3 || '',
    communicationName: name || '',
    companyEnglishName: name || '',
    companyLegalName: data.legalCompanyName || '',
    city: data.city || '',
    state: data.stateProvince || '',
    zipCode: data.postalCode || '',
    country: data.country || '',
    countryCode: data.countryCode || '',
    hierarchyType: data.partnerHierarchy,
    taxId: data.taxID || '',
    status: data.partnerStatus || '',
    partnerId: data.partnerId || '',
    storeNumber: data.storeNumber || '',
    url: data.url || '',
    locationId: data.locatorNumber || '',
    parentLocationId: data.parentLocatorNumber || '',
  }
}
